var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-page',[_c('query-config')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }